import React, { useEffect, useState } from 'react';
import UserLayout from '../../layout/UserLayout';
import { useNavigate } from 'react-router-dom';
import { useUploadAvatarMutation, useUploadCNICMutation, useUploadDrivingLicenseMutation, useUploadVehicleRegistrationMutation } from '../../../redux/api/driverApi';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import MetaData from '../../layout/MetaData'
import '../../../css/Driver.css';

const UploadCnic = () => {
    const { user } = useSelector((state) => state.auth);

    const [CNIC, setCNIC] = useState('');
    const [DrivingLicense, setDrivingLicense] = useState('');
    const [VehicleRegistration, setVehicleRegistration] = useState('');
    const [avatar, setAvatar] = useState('');

    const [CNICPreview, setCNICPreview] = useState(user?.CNIC ? user?.CNIC?.url : '/images/default_cnic.jpg');
    const [DLPreview, setDLPreview] = useState(user?.DrivingLicense ? user?.DrivingLicense?.url : '/images/default_cnic.jpg');
    const [VRPreview, setVRPreview] = useState(user?.VehicleRegistration ? user?.VehicleRegistration?.url : '/images/default_cnic.jpg');
    const [avatarPreview, setAvatarPreview] = useState(user?.avatar ? user?.avatar?.url : '/images/default_avatar.jpg'); // Avatar preview state

    const navigate = useNavigate();
    
    const [uploadAvatar, { isLoading: isAvatarLoading, error: avatarError, isSuccess: isAvatarSuccess }] = useUploadAvatarMutation();
    const [uploadCNIC, { isLoading: isCNICLoading, error: CNICError, isSuccess: isCNICSuccess }] = useUploadCNICMutation();
    const [uploadDrivingLicense, { isLoading: isDLLoading, error: DLError, isSuccess: isDLSuccess }] = useUploadDrivingLicenseMutation();
    const [uploadVehicleRegistration, { isLoading: isVRLoading, error: VRError, isSuccess: isVRSuccess }] = useUploadVehicleRegistrationMutation();
    
    useEffect(() => {
        if (avatarError) toast.error(avatarError?.data?.message);
        if (CNICError) toast.error(CNICError?.data?.message);
        if (DLError) toast.error(DLError?.data?.message);
        if (VRError) toast.error(VRError?.data?.message);

        if (isAvatarSuccess || isCNICSuccess || isDLSuccess || isVRSuccess) {
            toast.success('دستاویزات کامیابی سے اپ لوڈ ہو گئیں۔');
            navigate('/');

            setTimeout(() => {
                window.location.reload();
            }, 5000); // Reloads after 5 seconds

        }
    }, [avatarError, CNICError, DLError, VRError, isAvatarSuccess, isCNICSuccess, isDLSuccess, isVRSuccess]);

    const submitHandler = (e) => {
        e.preventDefault();
  
        if (avatar) uploadAvatar({ avatar });
        if (CNIC) uploadCNIC({ CNIC });
        if (DrivingLicense) uploadDrivingLicense({ drivingLicense: DrivingLicense });
        if (VehicleRegistration) uploadVehicleRegistration({ vehicleRegistration: VehicleRegistration });             
    
 
    };
  
    const handleFileChange = (e, setPreview, setFile) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                console.log("File Uploaded:", reader.result); // Debugging
                setPreview(reader.result);
                setFile(reader.result);
            }
        };
        reader.readAsDataURL(e.target.files[0]);
    };
    

    return (
        <>
            <MetaData title={'Upload Documents'} />
            <div className="row wrapper">
                <div className="col-10 col-lg-8">
                    <form className="shadow rounded bg-body" onSubmit={submitHandler}>
                    <h2 className="mb-4" id='driveruploadheading'>تصاویرےاپ لوڈ کریں۔</h2>
                    <br></br>
                        <h2 className="mb-4" id='driveruploadheading'>تصاویرے اپ لوڈ کرنا لازمی ہے۔</h2>

                        {/* Avatar upload */}
                        <div className="mb-3">
                            <div className="d-flex align-items-center">
                                <div className="me-3"> 
                                <figure className="document item-rtl">
                                            <img src={avatarPreview} className="rounded-circle" alt="PFP" id='imgpreview' />  
                                        </figure>
                                    </div>
                                    <div className="input-foam">
                                        <br></br>
                                        <label className="form-label" htmlFor={'file-avatar'}>
                                        <h4>اپنی تصویر اپ لوڈ کریں۔</h4>
                                        </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="file-avatar"
                                        accept="image/*"
                                        onChange={(e) => handleFileChange(e, setAvatarPreview, setAvatar)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Other document uploads */}
                        {[{
                            label: ' شناختی کارڈ',
                            preview: CNICPreview,
                            setFile: setCNIC,
                            setPreview: setCNICPreview
                        }, {
                            label: ' ڈرائیونگ لائسنس',
                            preview: DLPreview,
                            setFile: setDrivingLicense,
                            setPreview: setDLPreview
                        }, {
                            label: ' گاڑی کی رجسٹریشن',
                            preview: VRPreview,
                            setFile: setVehicleRegistration,
                            setPreview: setVRPreview
                        }].map(({ label, preview, setFile, setPreview }, index) => (
                            <div className="mb-3" key={index}>
                                <div className="d-flex align-items-center">
                                    <div className="me-3">
                                        <figure className="document item-rtl">
                                            <img src={preview} className="rounded-circle" alt="Image" id='imgpreview' />  
                                        </figure>
                                    </div>
                                    <div className="input-foam">
                                        <br></br>
                                        <label className="form-label" htmlFor={`file-${index}`}>
                                        <h4>
                                         {label} درج کارین
                                         </h4>
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id={`file-${index}`}
                                            accept="image/*"
                                            onChange={(e) => handleFileChange(e, setPreview, setFile)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                        <button
                            id="upload_button"
                            type="submit"
                            className="btn w-100 py-2"
                            disabled={isAvatarLoading || isCNICLoading || isDLLoading || isVRLoading}
                        >
                            {isAvatarLoading || isCNICLoading || isDLLoading || isVRLoading ? 'Uploading...' : 'Upload'}
                        </button>
                    </form>
                </div>
            </div>
  
        </>
    );
};

export default UploadCnic;
